module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACGSURBVHgBVY7RDcIwDESf3TJFgX9+mKGbkE7WsEm7AgL1H+ZISqw2UWPJ8vnO8p0sdCM0043vk0MtXB+R0GuAORK9EbUYfUBnMeJN5wQZFXW2b6IMd36+vLSjD+fV+sXFZV4zaGjWjE9IwW3tKYOawZYJC94exeyZ7MqRpMVHdKoC7ZnS6P+Lr0Eg45Jk7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/remove.png
// module id = 8smp
// module chunks = 36